var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReconfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(-9138 -268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 12,
    height: 12,
    transform: "translate(9138 268)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M9145.172,269.323l.42-.419a1.34,1.34,0,0,1,1.854,0l.339.338a1.3,1.3,0,0,1,0,1.849l-.42.419-2.192-2.192Zm-.5.505-4.341,4.341a.814.814,0,0,0-.238.515l-.129,1.4a.615.615,0,0,0,.172.477.588.588,0,0,0,.419.176h.052l1.4-.128a.84.84,0,0,0,.514-.244l4.341-4.341-2.191-2.192Zm4.456,9.282a.36.36,0,0,0-.358-.357h-9.529a.357.357,0,1,0,0,.715h9.529A.36.36,0,0,0,9149.123,279.11Z",
    fill: "#18c99d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReconfig);
export default __webpack_public_path__ + "static/media/icon-reconfig.44b6f07e1b1a11ecbe1ac2d851f30297.svg";
export { ForwardRef as ReactComponent };